export function wrap(angle) {
  return Math.atan2(Math.sin(angle), Math.cos(angle));
}
